export default {
	lang: 'ja',
	download: {
		"download01": 'Windows',
		"download02": 'Mac',
		"download03": 'iOS',
		"download04": 'Android',
		"download05": '今すぐダウンロード',
		"download": 'ダウンロード',
		"download2": 'モバイル',
		"download3": 'スマートフォンのQRコードをスキャンしてiOS/Androidをダウンロード',
		"download4": 'QRコード',
		"download5": 'Windows',
		"download6": '64ビット版Windows 10以降に対応',
		"download7": 'macOS',
		"download8": 'macOS 10.14以降に対応',
		"download9": 'App Store',
		"download10": 'macOS 10.14以降に対応',
		"download11": 'Android',
		"download12": 'Android 10.14以降をサポート',
	},
	home: {
		"home": 'ホーム',
		"XiaobeiBigModel": 'Xiaobei ビッグモデル',
		"AIcapability": 'AI機能',
		"Solution": "解決",
		"Login/Regis": "ログイン/登録",
		"home2": "カスタマーサービスホットライン",
		"home20": "テキスト翻訳",
		"home18": "音声認識",
		"home28": "特許数",
		"MediaCenter": "メディアセンター",
		"home46": "認証",
		"home54": "スマートオフィス",
		"home22": "一般的なQ&amp;A",
		"home32": "解決",
		"home38": "研究開発",
		"home26": "技術スタッフ",
		"home581": "音声認識 ",
		"home40": "品質管理",
		"home50": "詳細を確認する",
		"home34": "関連ソリューション",
		"home48": "ニュース",
		"home16": "OCR認識",
		"home601": "音声合成",
		"home": "表紙",
		"XiaobeiBigModel": "小型モデル",
		"AboutUs": "私たちについて",
		"ProductCenter": "製品センター",
		"home62": "画像翻訳",
		"home582": "音声合成 ",
		"home30": "（億元）",
		"AIcapability": "AI機能",
		"home1": "コアコンピテンシー",
		"home60": "音声合成",
		"home3": "連絡先番号",
		"home17": "AIインテリジェンス",
		"home21": "写真翻訳",
		"home27": "研究開発投資",
		"home23": "ビデオコース",
		"home29": "（パーセンテージ）",
		"home64": "自然言語処理",
		"home31": "（アイテム）",
		"home24": "小北AI大型モデル",
		"home39": "生産",
		"home19": "権威ある辞書",
		"home14": "AIエンパワーメントは、インテリジェントハードウェアをキャリアとして利用し、フルスタックの機能とサービスを提供します。",
		"home55": "スマート教育",
		"home44": "品質検査員がすべてのステップをチェックし、ISO9001管理システムを導入しています。",
		"home51": "パートナー",
		"home53": "協力相談",
		"home41": "アフターサポート",
		"home57": "音声認識",
		"home621": "一般コース",
		"home61": "テキスト翻訳",
		"home56": "スマートカーボックス",
		"home52": "人工知能ハードウェア市場に焦点を当て、専門的なOEM / 0DMサービスを提供",
		"home36": "フルスタックサービス",
		"home42": "OCR、音声認識、翻訳、AI、ヒューマンコンピュータインタラクションの分野で長年の研究開発能力を持つ、専門的なソフトウェアおよびハードウェアの研究開発チーム",
		"home603": "もうない",
		"home63": "音声翻訳",
		"home58": "ジグソーアルゴリズム",
		"home641": "自然言語処理",
		"home602": "自然言語処理",
		"home35": "関連製品の機能",
		"home15": "ジグソーアルゴリズム",
		"home25": "技術は主要な生産力である",
		"home572": "音声認識",
		"home591": "音声翻訳",
		"home47": "国内外で100件以上の特許",
		"home611": "権威ある辞書",
		"home571": "OCR認識",
		"home37": "AIエンパワーメントは、インテリジェントハードウェアをキャリアとして利用し、フルスタックの機能とサービスを提供します。",
		"home631": "一般的なQ&amp;A",
		"home592": "音声翻訳",
		"home49": "最新ニュースをご覧ください",
		"home43": "ソース工場、安定したサプライチェーン、厳格なインテリジェントプロセス生産",
		"home45": "タイムリーな対応、集中的なソリューション、1対1のサービスを提供するために、国内外に専門的なアフターセールス サポート チームを設立します。",
		"home33": "BeiBo は、オフィス、教育、車載ボックスなどのさまざまなシナリオのアプリケーシ…独自の研究開発能力とサービス コンセプトに基づいて顧客にワンストップ ソリューションを提供します。",
		"home59": "OCR認識",
		"home60": '音声合成',
		"home61": 'テキスト翻訳',
		"home62": '画像翻訳',
		"home63": '音声翻訳',
		"home64": '自然言語処理技術',
		"home571": 'OCR認識',
		"home581": '音声認識',
		"home591": '音声翻訳',
		"home601": '音声合成',
		"home611": '権威ある辞書',
		"home621": '全教科コース',
		"home631": '全教科Q&A',
		"home641": '自然言語処理技術',
		"home572": '音声認識',
		"home582": '音声合成',
		"home592": '音声翻訳',
		"home602": '自然言語処理技術',
		"home603": 'もう終わり',
	},
	consult: {
		"tilte": "ビジネス協力に関するあらゆるサービスを心を込めてご提供いたします",
		"subtilte": "ご連絡先をご記入いただければ、できるだけ早くご連絡いたします",
		"name": "お名前を入力してください",
		"phone": "電話番号を入力してください",
		"mailbox": "メールアドレスを入力してください",
		"mailboxerr": "メールの形式エラーです",
		"company": "会社名を入力してください",
		"desc": "ご要望を入力してください",
		"but": "送信内容をご確認ください",
		"region": "中国",
		"select": "選択してください",
		"submitSuccess": "送信に成功しました",
		"submitError": "送信に失敗しました",
	},
	ProDetails: {
		"ProDetails1": 'カスタマイズプロセス',
		"ProDetails2": '人工知能ハードウェア市場に注力し、プロフェッショナルなOEM/ODMサービスを提供する',
	},
	aiCapacity: {
		"aiMode1": 'AI機能',
		"aiMode2": 'ビッグデータ、ナレッジグラフ、機械学習、言語学などの技術を基盤に、AIコア技術とスマートハードウェアアプリケーションの研究に注力し、革新を続けています。',
		"aiMode3": '協力相談',
		"aiMode4": 'コア機能',
		"aiMode5": 'AIエンパワーメント、スマートハードウェアをキャリアとして活用し、フルスタックの機能とサービスを提供',
		"aiMode6": 'ジグソーアルゴリズム',
		"aiMode7": '小さな断片を大きな画像に統合して認識し、50以上の言語に対応',
		"aiMode8": 'OCR認識',
		"aiMode9": '画像処理とパターン認識技術によりテキストを抽出。50以上の言語に対応',
		"aiMode10": '音声認識',
		"aiMode11": '長短の音声を正確に認識してテキストに変換します。 130以上の言語に対応',
		"aiMode12": '音声合成',
		"aiMode13": 'テキストを自然で流暢な人間の音声に変換します。130以上の言語に対応',
		"aiMode14": 'テキスト翻訳',
		"aiMode15": 'テキストを対象言語から指定の言語に変換します。130以上の言語に対応',
		"aiMode16": '画像翻訳',
		"aiMode17": '画像テキスト認識と翻訳。130以上の言語に対応',
		"aiMode18": '音声翻訳',
		"aiMode19": '長短を問わず音声を正確に認識して翻訳します。 130以上の言語に対応',
		"aiMode20": '自然言語処理技術',
		"aiMode21": 'ビッグデータ、知識、言語技術の理解に基づいたQ&A、対話などのアプリケーションを実現',
		"aiMode22": '権威ある辞書',
		"aiMode23": '権威ある機関との緊密な連携により、オックスフォード、ロングマン、各種言語の正規辞書を提供',
		"aiMode24": 'ビデオコース',
		"aiMode25": '全科目のビデオコース、教科書は同期更新、プレビューや復習に最適',
		"aiMode26": '全科目のQ&A',
		"aiMode27": '全科目のQ&A解釈、類推トレーニング、学習効率向上',
		"aiMode28": '小北AIビッグモデル',
		"aiMode29": 'マルチモードインタラクション',
		"aiMode30": 'テキスト、音声、ビデオによるマルチモードインタラクション',
		"aiMode31": 'コーディング能力',
		"aiMode32": 'コード生成、解釈、エラー修正、テスト',
		"aiMode33": 'テキスト生成',
		"aiMode34": 'エッセイ、マーケティング、プレスリリース作成など',
		"aiMode35": '一般的な科目能力',
		"aiMode36": 'あらゆる学年段階における問題設定と問題解決',
		"aiMode37": '言語理解',
		"aiMode38": '要約抽出、文法チェック、感情分析',
		"aiMode39": '知識に関する質疑応答',
		"aiMode40": '生活、仕事、医学、歴史に関する知識',
		"aiMode41": '論理的推論',
		"aiMode42": '思考、科学、常識に基づく推論',
		"aiMode43": "多言語対応",
		"aiMode44": "100以上の言語インタラクションをサポート",
		"aiMode45": "技術的優位性",
		"aiMode46": "2億の高精度コーパス",
		"aiMode47": "スマートオフィス、スマート教育、スマートカーなどで幅広く活用",
		"aiMode48": "グローバル連携技術",
		"aiMode49": "超低遅延、安全かつ安定、インテリジェントなスケジューリング、安定した接続",
		"aiMode50": "安全な暗号化システム",
		"aiMode51": "国際的に先進的なクラウド・パイプエンド・データ4次元暗号化システム、全プロセス暗号化",
	},
	aiMode: {
		"aiMode1": 'Xiaobei AI Big Model',
		"aiMode2": '大規模ニューラルネットワーク学習に基づく自然言語処理モデル。自然言語理解、自然言語生成、対話インタラクション、知識に基づく質疑応答、文学創作など、多様な機能を備えています。創造性を解き放ち、ワークフローを効率化し、スマートハードウェアを強化します。 ',
		"aiMode3": '協力相談',
		"aiMode4": '多様な機能',
		"aiMode5": 'AIエンパワーメント、スマートハードウェアをキャリアとして活用し、フルスタックの機能とサービスを提供',
		"aiMode6": 'マルチモーダルインタラクション',
		"aiMode7": 'テキスト、音声、ビデオによるマルチモーダルインタラクション',
		"aiMode8": 'コード機能',
		"aiMode9": 'コード生成、解釈、エラー修正、テスト',
		"aiMode10": 'テキスト生成',
		"aiMode11": '作文、マーケティング、プレスリリース作成など',
		"aiMode12": 'オールラウンドな機能',
		"aiMode13": 'あらゆる学問分野のプログラミングと問題解決',
		"aiMode14": '言語理解',
		"aiMode15": '要約抽出、文法チェック、感情分析',
		"aiMode16": "知識クイズ",
		"aiMode17": "人生、仕事、医学、歴史に関する知識",
		"aiMode18": "論理的推論",
		"aiMode19": "思考、科学、常識に基づく推論",
		"aiMode20": "多言語対応",
		"aiMode21": "100以上の言語インタラクションに対応",
		"aiMode22": "当社の強み",
		"aiMode23": "擬人化音声インタラクション",
		"aiMode24": "人間の声の特徴、イントネーション、言語スタイルをシミュレートすることで、人間とコンピュータ間の対話をより自然で親しみやすくし、ユーザーエクスペリエンスを向上させます",
		"aiMode25": "ワンクリックでインテリジェントなライティング",
		"aiMode26": "厳格な需要シナリオに対応するため、効率的で使いやすく、インテリジェントな」オフィス効率化ツールを作成します」 AIによるワンクリック書き込みとキャリブレーションにより、作業の要約とレポート作成が簡単かつ効率的になり、AI時代の効率化ツールとなります。",
		"aiMode27": 'フルシナリオ対応インテリジェントアシスタント',
		"aiMode28": '複数の機能とサービスを統合し、ユーザーに包括的なサポートと利便性を提供するインテリジェントアシスタントアプリケーション',
		"aiMode29": '迅速な応答',
		"aiMode30": '効率的な処理',
		"aiMode31": 'ストリーミングインターフェース設計を採用し、最初のフレームへの応答は数ミリ秒単位です。効率的なアルゴリズムとアーキテクチャの助けを借りて、非常に短時間で多数のユーザーニーズに対応できます。',
		"aiMode32": '多様なシナリオ',
		"aiMode33": '継続的な進化',
		"aiMode34": '言語理解、知識に基づく質問と回答、コード記述、論理的推論、数学的問題解決など、複数の機能を提供し、膨大なデータと知識から継続的に学習し、進化します。',
		"aiMode35": '柔軟なアプリケーション',
		"aiMode36": 'パーソナルカスタマイズ',
		"aiMode37": '豊富なパラメータ設定を提供し、パーソナライズされたモデルエクスペリエンスを実現します。エンタープライズレベルのカスタマイズされたニーズには、専用のモデルソリューションを提供できます。',
		"aiMode38": '安定したサービス',
		"aiMode39": '安全で信頼性の高い',
		"aiMode40": 'このクラウドサービスは、第3レベルのセキュリティ保護基準を満たし、数千億トラフィックに対応するパブリッククラウドアーキテクチャを採用しています。データ暗号化、アクセス制御、その他の複数の手段を組み合わせることで、ユーザーのプライバシーとセキュリティを確保します。'
	},
	Product: {
		"Product1": '製品センター',
		"Product2": 'オフィス、教育、車載用スマート製品の注文と機能カスタマイズのサポート',
		"Product3": '協力相談',
	},
	medium: {
		"medium1": 'メディアセンター',
		"medium2": '北博の最新ニュースはこちらをご覧ください',
		"medium3": '協力相談',
	},
	about: {
		"about1": 'BeiBoについて',
		"about2": 'オフィス、教育、車載ボックスなど向けのスマートハードウェアソリューションプロバイダー',
		"about3": '協力相談',
		"about4": '会社概要',
		"about5": '資格認証',
		"about6": '国内外で100件以上の特許',
		"about7": '深セン北博智能科技有限公司',
		"about8": '2015年に設立された北博智能は、中国の「スマート製造」の中心地である深センに拠点を置いています。国家レベルのハイテク企業であり、先進的なビジョンと革新精神を持つ専門性の高い革新的な企業です。 ',
		"about9": "当社はAI音声の垂直分業に注力し、強力なAIソフトウェア＋ハードウェア研究開発能力を有しています。AI音声、AI翻訳、AI OCR、AIヒューマン・ビークル・インタラクション、AIクラウドなどのAI技術を世に送り出すことで、AIハードウェアの強化に貢献しています。自社開発の音声翻訳AIモデルは、最新のAIマルチモーダル技術とAIGC技術を統合し、チッププラットフォームとハードウェアソリューションの研究開発設計に基づき、様々な分野の顧客にフルスタックのAI音声技術ソリューションを提供しています。教育、政府、企業、軍事分野では、成熟した業界ソリューションを有しています。また、コンシューマー向けには、AI翻訳機、AIボイスレコーダー、AIスキャナー、AIカーボックスなどのAIハードウェアが年間100万台以上を販売しています。日本、欧州、米国に複数の戦略的パートナーを擁し、人々が言語の壁を乗り越えるためのAI音声技術ソリューションを提供する世界有数のリー​​ディングプロバイダーです。",
		"about10": '',
	},
	footer: {
		"AboutUs": '会社概要',
		"CollaborativeConsulting": '協力相談',
		"Businesscooperation": 'ビジネス協力',
		"phone": '連絡先:',
		"phone2": '+86 13660736734',
		"phone3": 'hangou@szbbzn.com',
		"tel": '0755 27189290',
		"address": '深圳市龍華区大朗街桃園社区元分工業区201号F室',
		"copyright": 'Copyright © 深圳北博智能科技有限公司',
		"icp": '粤ICP備2024241358号-1',
		"footer2": '登録へようこそ',
		"footer3": '既に登録済みアカウントをお持ちですか？',
		"footer4": 'ログインしてください',
	},
	login: {
		"login1": 'パスワードログイン',
		"login2": 'SMSログイン',
		"loginTab3": 'メールログイン',
		"login3": 'メールアドレス',
		"login4": 'ログインパスワード',
		"login5": '携帯電話番号',
		"login6": '選択してください',
		"login7": '携帯電話認証コード',
		"login8": 'ログイン',
		"login9": 'パスワードを忘れた場合',
		"login10": '登録',
		"login11": 'ログインすると同意したものとみなされます',
		"login12": 'サービス規約',
		"login13": 'プライバシーポリシー',
		"login14": '取得',
		"login15": '中国',
		"login16": 'アカウントを入力してください',
		"login17": 'パスワード',
		"login18": 'ログイン成功！',
		"login19": '確認コードを入力してください！',
		"login20": '送信成功！',
		"login21": 'そして',
		"login22": 'レコーダークラウドディスク',
		"login23": '私の書き込み',
		"login24": '私の会話',
		"login25": 'アカウントセキュリティ',
		"login26": 'ログアウト',
		"login27": 'メールパスワードの取得',
		"login28": 'メールアドレス',
		"login29": 'メール確認コード',
		"login30": 'ログインパスワードを設定（6～16文字）',
		"login31": 'ログインパスワードをもう一度入力',
		"login32": '送信',
		"login33": '戻るログイン',
		"login34": '変更に成功しました!',
	},
	register: {
		"register1": '携帯電話番号',
		"register2": '携帯電話番号を入力してください',
		"register3": '選択してください',
		"register4": '携帯電話認証コード',
		"register5": 'パスワードを設定',
		"register6": '認証コードを入力してください',
		"register7": '6～16文字',
		"register8": 'パスワードの確認',
		"register9": 'メールアドレス',
		"register10": 'メールアドレスを入力してください',
		"register11": 'メールアドレス認証コード',
		"register12": '認証コードを入力してください',
		"register13": '利用規約を読み、同意しました',
		"register14": '利用規約を読んで確認してください',
		"register15": '携帯電話番号の形式が間違っています / 携帯電話番号が登録されています',
		"register16": '携帯電話認証コードが間違っています',
		"register17": 'メールアドレスを入力してください / メールアドレスの形式エラー',
		"register18": 'メール形式エラー',
		"register19": 'メール確認コードエラー',
		"register20": 'パスワードを6～16文字に設定してください',
		"register21": 'パスワード形式エラー',
		"register22": '2つのパスワードが一致していません。再入力してください',
		"register23": 'パスワードを入力してください',
		"register24": '登録成功！',
		"register25": '確認コードエラー',
	},
	recorder: {
		"recorder1": 'レコーダーペンのクラウドディスク',
		"recorder2": 'クラウドスペースの容量',
		"recorder3": 'ファイル',
		"recorder331": 'ごみ箱',
		"recorder332": 'すべて消去',
		"recorder4": '名前',
		"recorder5": '音声の長さ',
		"recorder6": 'ファイルサイズ',
		"recorder7": '作成時間',
		"recorder8": '操作',
		"recorder9": 'クラウドスペースの説明',
		"recorder10": 'ファイル',
		"recorder11": 'OCRファイル',
		"recorder12": '1. クラウドスペースは何に使用されますか？',
		"recorder13": 'レコーダーで録音した後、音声ファイルと文字起こしファイルをクラウドスペースにアップロードできます。レコーダーが手元になくても、クラウドスペースにアクセスして音声を確認できます。',
		"recorder14": '2. クラウドスペースへのアップロード方法',
		"recorder15": 'レコーダーの[マイファイル]に入り、対象のファイルを選択して長押しするとオプションが表示されます。「アップロード」をクリックして、ファイルをクラウドスペースにアップロードします。',
		"recorder16": '3. クラウドスペースのファイルを表示/管理する方法',
		"recorder17": 'Beibo公式サイトにログインし、「マイレコーダークラウドディスク」を選択すると、アップロードされたレコーダーファイルを確認できます。対象ファイルを選択することで、ダウンロード、削除などの操作が可能です。クラウドファイルを削除することで、クラウドストレージをクリーンアップできます！',
		"recorder18": '未転記',
		"recorder19": '概要を表示',
		"recorder20": '発言者',
		"recorder21": '発言者名を編集',
		"recorder22": '確認',
		"recorder23": 'ダウンロード',
		"recorder24": 'コンテンツのダウンロード:',
		"recorder25": 'ダウンロード設定:',
		"recorder26": '発言者を表示',
		"recorder27": 'キャンセル',
		"recorder28": 'リンクの共有',
		"recorder29": 'リンクを受け取った人なら誰でもアクセスできます。読み取りのみサポートされています。リンクは7日間有効です。',
		"recorder30": 'リンクをコピー',
		"recorder31": 'スキャンしてすぐに表示',
		"recorder32": 'スマートな整理',
		"recorder33": '話者を区別',
		"recorder34": '話者の役割に応じて書き起こしテキストをインテリジェントに区別',
		"recorder35": 'インテリジェントな話し言葉の正規化',
		"recorder36": '助詞、繰り返し単語、一時停止単語を自動的にフィルタリング',
		"recorder37": '音声以外のフィルタリング',
		"recorder38": '再生中に人の声やノイズのない音声を自動的にスキップ',
		"recorder39": '選択してください',
		"recorder40": 'ドキュメント',
		"recorder41": 'オーディオ',
		"recorder42": 'ドキュメント+オーディオ',
		"recorder43": "プロンプト",
		"recorder44": "この操作によりファイルが削除されます。続行しますか？",
		"recorder441": "この操作によりすべてのファイルが削除されます。続行しますか？",
		"recorder45": "確認",
		"recorder46": "キャンセル",
		"recorder47": "正常に削除されました！",
		"recorder48": "削除をキャンセルしました",
		"recorder49": "まだマークされていません",
		"recorder50": "保存中...",
		"recorder51": "ごみ箱",
	},
	personal: {
		"personal1": 'アカウント設定',
		"personal2": '個人情報',
		"personal3": 'アバター',
		"personal4": 'ファイルのアップロード',
		"personal5": 'JPG、JPEG、GIF、PNG形式に対応、2MB以内の画像に対応',
		"personal6": 'ニックネーム',
		"personal7": 'ニックネームを入力してください',
		"personal8": '性別',
		"personal9": 'Mr.',
		"personal10": 'Ms.',
		"personal11": '機密情報',
		"personal12": '誕生日',
		"personal13": '生年月日を選択してください',
		"personal14": '職業',
		"personal15": '職業を選択してください',
		"personal16": '職業を入力してください(オプション)',
		"personal17": '国',
		"personal18": '国を選択してください',
		"personal19": '保存',
		"personal20": '個人情報',
		"personal21": 'アカウントのセキュリティ',
		"personal22": '2M以内の画像のみサポートされます',
		"personal23": 'アップロードに成功しました！',
		"personal24": '変更に成功しました！',
		"personal25": 'アカウントのセキュリティ',
		"personal26": 'ログインパスワード',
		"personal27": '変更',
		"personal28": 'メールアドレス',
		"personal29": '変更',
		"personal30": 'アカウントのキャンセル',
		"personal32": 'アカウントをキャンセルしてもよろしいですか？',
		"personal33": 'キャンセル後、あなたのアカウントにあるすべてのコンテンツはアカウントがクリアされますので、注意して操作してください。 ',
		"personal34": 'キャンセル',
		"personal35": '確認',
		"personal36": '認証',
		"personal37": '操作しているのがご本人様であることを確認するため、メールの確認コードで本人確認を完了してください',
		"personal38": 'メールアドレス',
		"personal39": '確認コード',
		"personal40": '確認コードを入力してください',
		"personal41": '次へ',
		"personal42": '新しいメールアドレスを設定',
		"personal43": 'メールアドレス',
		"personal44": '新しいメールアドレスを入力してください',
		"personal45": '確認コード',
		"personal46": '確認コードを入力してください',
		"personal47": '確認',
		"personal48": '新しいログインパスワードを設定',
		"personal49": '新規ログインパスワード',
		"personal50": '新しいパスワードを入力してください',
		"personal51": '新しいパスワードを確認',
		"personal52": '新しいパスワードをもう一度入力してください',
		"personal53": '確認',
		"personal54": '取得',
		"personal55": 'メールの形式エラー',
		"personal56": '変更に成功しました！',
		"personal57": 'パスワードは6～16文字に設定してください',
		"personal58": '入力した2つのパスワードが一致していません',
		"personal59": '変更に成功しました！',
		"personal60": 'ログアウトに成功しました！',
	}
}